import React from "react";
import "./integrations.css"; // Import your CSS file for styles
import classes from "./common.module.scss";
import qb from "../../assets/images/integration/qb.png";
import xero from "../../assets/images/integration//xero.png";
import freshbooks from "../../assets/images/integration/freshbooks.png";
import oracle from "../../assets/images/integration/oracle.png";
import sap from "../../assets/images/integration/sap.png";
import microsoftDynamic from "../../assets/images/integration/dynamic_insigma.png";
import yodlee from "../../assets/images/integration/yodlee_1.png";
import plaid from "../../assets/images/integration/plaid.png";
import trueLayer from "../../assets/images/integration/truelayer_logo.png";
import stripe from "../../assets/images/integration/stripe.png";
import salesforce from "../../assets/images/integration/salesforce.png";
import asana from "../../assets/images/integration/asana.png";
import slack from "../../assets/images/integration/slack.png";
import infor from "../../assets/images/integration/infor.png";
import odoo from "../../assets/images/integration/odoo.png";

const IntegrationTwo = () => {

  // All platforms in a single array for the marquee
  const platforms = [
    { name: "QuickBooks", icon: qb },
    {
      name: "Xero",
      icon: xero,
    },
    {
      name: "FreshBooks",
      icon: freshbooks,
    },
    {
      name: "NetSuite",
      icon: oracle,
    },
    { name: "SAP", icon: sap },
    {
      name: "Dynamics 365",
      icon: microsoftDynamic,
    },
    { name: "Yodlee", icon: yodlee },
    {
      name: "Plaid",
      icon: plaid,
    },
    {
      name: "TrueLayer",
      icon: trueLayer,
    },
    {
      name: "Stripe",
      icon: stripe,
    },
    {
      name: "Salesforce",
      icon: salesforce,
    },
    {
      name: "Asana",
      icon: asana,
    },
    {
      name: "Slack",
      icon: slack,
    },
    {
      name: "Infor",
      icon: infor,
    },
    {
      name: "Odoo",
      icon: odoo,
    },
  ];

  return (
    <div className="integrations-page">
      <div className="container">
        <div className="integrations-header">
          <h2>Instantly Integrate with 300+ apps</h2>
          {/* <p>
            Radar+ is more than just risk and opportunity detection. With
            powerful integrations and advanced automation capabilities, you can
            seamlessly connect to your ecosystem, enabling real-time actions
            that proactively address critical challenges, uncover growth
            opportunities, and drive smarter, faster decisions across your
            entire business landscape.
          </p> */}
        </div>

        <div className="integrations-content">
          <div className="integrations-marquee">
            <div className="marquee-wrapper">
              {[...platforms, ...platforms].map((platform, index) => (
                <div key={index} className="platform-card">
                  <div className={classes.integrationTag}>
                    <div>
                      <img
                        src={platform.icon}
                        height={20}
                        alt={`${platform.name} icon`}
                      />
                    </div>
                    <span style={{ fontSize: 16 }}>{platform.name}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntegrationTwo;
